import React, { useContext } from 'react'
import Nav from 'react-bootstrap/Nav'
import NavDropdown from 'react-bootstrap/NavDropdown'

import { SelfUser } from 'js/utils/helpers'
import Paths from 'js/utils/paths'
import VQCPermissions from 'js/utils/permissions'
import UnauthorizedPaths from 'js/utils/unauthorizedPaths'
import HeaderWrapper from './HeaderWrapper'
import { Link } from 'react-router-dom'
import { SignOut } from 'js/services/auth'

export default function Header(): React.ReactElement {
  const selfUser = useContext(SelfUser)
  const isElitechAdmin = VQCPermissions.isElitechAdmin(selfUser)
  const viewCustomerData = VQCPermissions.canViewCustomerData(selfUser)
  const viewElitechData = VQCPermissions.canViewElitechData(selfUser)

  return (
    <HeaderWrapper>
      {isElitechAdmin && (
        <NavDropdown title='Admin' id='basic-nav-dropdown'>
          {viewCustomerData && (
            <>
              <NavDropdown.Item as={Link} to={Paths.adminOrganizations}>
                Organizations
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to={Paths.adminUsers}>
                Users
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to={Paths.adminDevices}>
                Device Registrations
              </NavDropdown.Item>
            </>
          )}
          {viewElitechData && (
            <>
              <NavDropdown.Item as={Link} to={Paths.adminLotGroups}>
                Lot Management
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to={Paths.adminControlTypes}>
                Control Types
              </NavDropdown.Item>

              <NavDropdown.Item as={Link} to={Paths.adminDeviceTypes}>
                Device Models
              </NavDropdown.Item>
            </>
          )}
        </NavDropdown>
      )}

      <Nav.Link as={Link} to={Paths.controlRuns}>
        Control Runs
      </Nav.Link>

      {VQCPermissions.isOrganizationAdmin(selfUser) && (
        <Nav.Link
          as={Link}
          to={Paths.getAdminOrganizationDetailLink(selfUser.organization)}
        >
          Organization Settings
        </Nav.Link>
      )}

      <Nav.Link as={Link} to={Paths.profile}>
        Profile
      </Nav.Link>

      <Nav.Link as={Link} to={UnauthorizedPaths.signIn} onClick={SignOut}>
        Sign Out
      </Nav.Link>
    </HeaderWrapper>
  )
}
